import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  InputLabel,
  TextField,
  Button,
  Divider,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Chip,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import * as actions from "./actions";
import * as commonActions from "../Common/actions";
import { API_URL, SHARE_BASE_URL } from "../../constants";
import moment from "moment";
import CustomShowModal from "../Common/customShowModal";
import ViewSong from "./ViewSong";
import ConfirmModal from "../Common/ConfirmModal";
import CustomAddModal from "../Common/CustomAddModal";
import ImagePreviewModal from "../Common/ImagePreviewModal";
import { toastSuccess, toastError, copyToClipboard } from "../../utils";
import SelectCMP from "react-select";
import darkSelectStyles from "../../theme/reactSelectStyles";
import ActionButton from "../../components/ActionButton";
import StatusBadge from "../../components/StatusBadge";
import CopyableField from "../../components/CopyableField";
import { ChevronDown, Copy } from "../../components/Icons";
import { AlertTriangle, RotateCcw, StickyNote } from "lucide-react";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

function ViewReleases(props) {
  const params = useParams();
  const navigate = useNavigate();

  const [release, setRelease] = useState({});
  const [openSong, setOpenSong] = useState(false);
  const [selectedSong, setSelectedSong] = useState({});
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openTakedownConfirm, setOpenTakedownConfirm] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [openReject, setOpenReject] = useState(false);
  const [openPromotion, setOpenPromotion] = useState(false);
  const [reasonText, setReasonText] = useState("");
  const [showSongModal, setShowSongModal] = useState(false);
  const [rejectOptions, setRejectOptions] = useState([]);
  const [platformOptions, setPlatformOptions] = useState([]);
  const [promoOptions, setPromoOptions] = useState([]);
  const [recipeFilePreview, setRecipeFilePreview] = useState(null);
  const [updatedPoster, setUpdatedPoster] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [editModal, setEditModal] = useState(false);
  const [editAudioModal, setEditAudioModal] = useState(false);
  const [openImagePreview, setOpenImagePreview] = useState(false);
  const [imageError, setImageError] = useState(false);

  const [editRelease, setEditRelease] = useState({
    lable_name: "",
    release_title: "",
    release_date: "",
    release_id: 0,
    upc_ean: "",
  });

  const [editAudio, setEditAudio] = useState([
    {
      audio_id: 0,
      title: "",
    },
  ]);

  const [promotionData, setPromotionData] = useState({
    song: "",
    platform: "",
    promotion: "",
    playlist_name: "",
    playlist_link: "",
  });

  const onFileHandler = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 1572864) {
        return toastError("File more than 1.5 MB is not allowed.");
      }
      props.setLoader(true);
      commonActions
        .upload(file)
        .then((res) => {
          props.setLoader(false);
          setUpdatedPoster(res.body.filename);
          setImageError(false);
          previewsFile(file);
          toastSuccess("Artwork uploaded successfully.");
        })
        .catch((err) => {
          props.setLoader(false);
          toastError(err.message || "Something went wrong");
        });
    }
  };

  const onPromotionFileHandler = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 1572864) {
        return toastError("File more than 1.5 MB is not allowed.");
      }
      props.setLoader(true);
      commonActions
        .promoImageUploadAdmin(file)
        .then((res) => {
          props.setLoader(false);
          setImagePreview(res.body.filename);
          toastSuccess("Image uploaded successfully.");
        })
        .catch((err) => {
          props.setLoader(false);
          toastError(err.message || "Something went wrong");
        });
    }
  };

  const onDelete = (item) => {
    props.setLoader(true);
    actions
      .deleteFileFromServer({ fileLink: item })
      .then((res) => {
        toastSuccess(res.message);
        return commonActions.updateAlbumArtworkAdmin({
          release_id: params.id,
          album_artwork: "",
        });
      })
      .then(() => {
        return actions.getNewReleaseByIdAdmin(params.id);
      })
      .then((res) => {
        setRelease(res.body);
        setRecipeFilePreview(null);
        setUpdatedPoster("");
        setImageError(false);
        props.setLoader(false);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err?.message || 'Failed to delete file');
      });
  };

  const onSaveUpdatedArtwork = () => {
    commonActions
      .updateAlbumArtworkAdmin({
        release_id: params.id,
        album_artwork: updatedPoster || "",
      })
      .then((res) => {
        toastSuccess(res.message || "Updated successfully");
        return actions.getNewReleaseByIdAdmin(params.id);
      })
      .then((res) => {
        setRelease(res.body);
        setRecipeFilePreview(null);
        setUpdatedPoster("");
        setImageError(false);
      })
      .catch((err) => {
        toastError(err.message);
      });
  };

  const previewsFile = (file) => {
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      function () {
        //convert
        setRecipeFilePreview(reader.result);
      },
      false
    );
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const onCreatePromotion = (toSendEmail) => {
    if (
      !(
        promotionData.song &&
        promotionData.platform &&
        promotionData.promotion &&
        promotionData.playlist_name &&
        promotionData.playlist_link &&
        imagePreview
      )
    ) {
      toastError("All fields are required");
      return;
    }
    props.setLoader(true);
    commonActions
      .createPromotionsAdmin({
        user_id: release.user_id,
        user_email: release.email,
        song: promotionData.song,
        platform: promotionData.platform.value,
        type: promotionData.promotion.value,
        playlist_name: promotionData.playlist_name,
        playlist_link: promotionData.playlist_link,
        image: imagePreview,
        isEmail: toSendEmail,
      })
      .then((res) => {
        toastSuccess(res.message || "Created successfully");
        setOpenPromotion(false);
        setPromotionData({
          user_id: "",
          song: "",
          platform: "",
          promotion: "",
          playlist_name: "",
          playlist_link: "",
          image: "",
        });
        setImagePreview(null);
        props.setLoader(false);
      })
      .catch((err) => {
        toastError(err.message);
      });
  };

  useEffect(() => {
    onGetRelease();
    onGetRejectOptions();
    onGetPromoTypesOptions();
    onGetPlatformsAdminOptions();
  }, []);

  const onGetRejectOptions = () => {
    actions.rejectReasonsAdmin().then((res) => {
      setRejectOptions(
        Array.isArray(res.body)
          ? res.body.map((item) => ({ label: item.reason, value: item.reason }))
          : []
      );
    }).catch((err) => {
      toastError(err?.message || 'Failed to load reject reasons');
    });
  };

  const onGetPromoTypesOptions = () => {
    actions.getPromoTypesAdmin().then((res) => {
      setPromoOptions(
        Array.isArray(res.body)
          ? res.body.map((item) => ({
              label: item.promo_type,
              value: item.promo_type,
            }))
          : []
      );
    }).catch((err) => {
      toastError(err?.message || 'Failed to load promo types');
    });
  };

  const onGetPlatformsAdminOptions = () => {
    actions.getPlatformsAdmin().then((res) => {
      setPlatformOptions(
        Array.isArray(res.body)
          ? res.body.map((item) => ({
              label: item.platform,
              value: item.platform,
            }))
          : []
      );
    }).catch((err) => {
      toastError(err?.message || 'Failed to load platforms');
    });
  };

  const onGetRelease = () => {
    props.setLoader(true);
    actions
      .getNewReleaseByIdAdmin(params.id)
      .then((res) => {
        props.setLoader(false);
        setRelease(res.body);
        setEditRelease({
          lable_name: res.body?.lable_name,
          release_title: res.body?.release_title,
          release_date: res.body?.release_date,
          release_id: params.id,
          upc_ean: res.body?.upc_ean || "",
        });

        if (res.body?.audios) {
          setEditAudio(
            res.body.audios.map((value) => ({
              audio_id: value.audio_id,
              title: value.title,
              isrc: value.isrc || "",
            }))
          );
        }
      })
      .catch((err) => {
        toastError(err?.message || "An error occured")
        props.setLoader(false);
      });
  };

  const onOpenModal = (item) => {
    setSelectedSong(item);
    setOpenSong(true);
  };

  const onConfirmAcceptModal = () => {
    props.setLoader(true);
    actions
      .changeReleaseStatusAdmin({ status: "approved", release_id: selectedId })
      .then((res) => {
        setOpenConfirm(false);
        onGetRelease();
        toastSuccess(res.message);
        props.setLoader(false);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err?.message || 'Failed to approve release');
      });
  };

  const onClickAccept = (id) => {
    setSelectedId(id);
    setOpenConfirm(true);
  };

  const onClickReject = (id) => {
    setSelectedId(id);
    setOpenReject(true);
  };

  const onSubmitReject = () => {
    props.setLoader(true);
    actions
      .changeReleaseStatusAdmin({
        release_id: selectedId,
        status: "rejected",
        reason: reasonText,
      })
      .then((res) => {
        setOpenReject(false);
        setShowSongModal(true);
        onGetRelease();
        toastSuccess(res.message);
        props.setLoader(false);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err?.message || 'Failed to reject release');
      });
  };

  const onRejectASong = (audio_id) => {
    props.setLoader(true);
    actions
      .rejectReleaseAudioAdmin({ audio_id })
      .then((res) => {
        onGetRelease();
        toastSuccess(res.message);
        props.setLoader(false);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err?.message || 'Failed to reject audio');
      });
  };

  const onDeleteRejectedRelease = (release_id) => {
    props.setLoader(true);
    actions
      .deleteRejectedRelease({ release_id })
      .then((res) => {
        toastSuccess(res.message);
        props.setLoader(false);
        return navigate("/release/rejected");
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err?.message || 'Failed to delete release');
      });
  };

  const keyPressedReason = (e) => {
    if (e.key === "Enter" && e.shiftKey) {
      return;
    } else if (e.key === "Enter") {
      e.preventDefault();
      onSubmitReject();
    } else return;
  };

  const onClickTakeDown = (id) => {
    setSelectedId(id);
    setOpenTakedownConfirm(true);
  };

  const onConfirmTakeDown = () => {
    props.setLoader(true);
    actions
      .changeReleaseStatusAdmin({ release_id: selectedId, status: "takendown" })
      .then((res) => {
        setOpenTakedownConfirm(false);
        onGetRelease();
        toastSuccess(res.message);
        props.setLoader(false);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err?.message || 'Failed to takedown release');
      });
  };

  const onEditRelease = () => {
    if (editRelease.upc_ean && !/^\d{12,13}$/.test(editRelease.upc_ean)) {
      return toastError("UPC/EAN must be 12 or 13 digits.");
    }
    props.setLoader(true);
    actions
      .editReleaseAdmin({
        release_id: editRelease.release_id,
        lable_name: editRelease.lable_name,
        release_title: editRelease.release_title,
        release_date: editRelease.release_date,
        upc_ean: editRelease.upc_ean,
      })
      .then((res) => {
        setEditModal(false);
        onGetRelease();
        toastSuccess(res.message || "Created successfully");
        props.setLoader(false);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err.message);
      });
  };

  const handleAudioChange = (index, field, value) => {
    setEditAudio((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const onEditTracks = () => {
    const seenIsrcs = {};
    for (let i = 0; i < editAudio.length; i++) {
      const { isrc } = editAudio[i];
      if (isrc && !/^[A-Z0-9]{12}$/.test(isrc)) {
        return toastError(`Track ${i + 1}: ISRC must be exactly 12 alphanumeric characters.`);
      }
      if (isrc) {
        if (seenIsrcs[isrc] !== undefined) {
          return toastError(`Track ${i + 1} and Track ${seenIsrcs[isrc] + 1} have the same ISRC (${isrc}).`);
        }
        seenIsrcs[isrc] = i;
      }
    }
    props.setLoader(true);
    actions
      .editAudioTitlesAdmin({
        updates: editAudio.map((item) => ({
          audio_id: item.audio_id,
          title: item.title,
          isrc: item.isrc,
        })),
      })
      .then((res) => {
        setEditAudioModal(false);
        onGetRelease();
        toastSuccess(res.message || "Edited successfully");
        props.setLoader(false);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err.message);
      });
  };

  const {
    album_artwork = "",
    apple_id1 = "",
    apple_id1f = "",
    apple_id2 = "",
    apple_id2f = "",
    apple_id3 = "",
    apple_id3f = "",
    audios = [],
    c_line = "",
    crbt = "",
    featuring1 = "",
    featuring2 = "",
    featuring3 = "",
    genre = "",
    lable_name = "",
    number_of_tracks = "",
    p_line = "",
    primary_artist1 = "",
    primary_artist2 = "",
    primary_artist3 = "",
    release_date = "",
    release_id = "",
    release_title = "",
    release_type = "",
    spotify_id1 = "",
    spotify_id1f = "",
    spotify_id2 = "",
    spotify_id2f = "",
    spotify_id3 = "",
    spotify_id3f = "",
    status = "",
    sub_genre = "",
    upc_ean = "",
    name = "",
    email = "",
    video_platforms = "",
    ogn_release_date = "",
    cour_line = "",
    add_info = "",
    reason = "",
    internal_notes = "",
  } = release;

  const tabPrefixMap = { in_review: 'RR', approved: 'AP', rejected: 'RE', takendown: 'TD' };

  useEffect(() => {
    const prefix = tabPrefixMap[status];
    if (prefix && release_title) {
      document.title = `${prefix} | ${release_title}`;
    }
    return () => { document.title = 'Fronic Media Admin'; };
  }, [status, release_title]);

  const trackStatusMap = { 0: 'in_review', 1: 'approved', 2: 'rejected', 3: 'takendown' };

  return (
    <Grid container className="view-release-container" spacing={3}>
      {/* ==================== TOP HEADER ==================== */}
      <Grid item xs={12}>
        <Box className="view-release-header">
          <Typography variant="h5" className="view-release-header__title">
            {release_title || 'Release Details'}
          </Typography>
          <Box className="view-release-header__meta">
            {status && <StatusBadge status={status} />}
            {status === "in_review" && reason && (
              <Chip
                icon={<RotateCcw size={11} />}
                label="Resubmission"
                size="small"
                sx={{
                  backgroundColor: 'rgba(239, 68, 68, 0.12)',
                  color: '#EF4444',
                  border: '1px solid rgba(239, 68, 68, 0.25)',
                  fontWeight: 700,
                  fontSize: '0.68rem',
                  height: 22,
                  letterSpacing: '0.03em',
                  textTransform: 'uppercase',
                  flexShrink: 0,
                  '& .MuiChip-icon': { color: '#EF4444', ml: '4px' },
                  '& .MuiChip-label': { px: '8px' },
                }}
              />
            )}
            <Typography variant="body2" className="view-release-header__id">
              FM-RL-{release_id}
            </Typography>
            <ActionButton
              variant="settle"
              onClick={() => document.getElementById('tracks-section')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Go to Tracks
            </ActionButton>
            <ActionButton
              variant="success"
              onClick={() => {
                const url = `${SHARE_BASE_URL}/view_releases/${release_id}`;
                navigator.clipboard.writeText(url).then(() => toastSuccess('Release link copied!'));
              }}
            >
              Copy Release
            </ActionButton>
          </Box>
        </Box>
      </Grid>

      {/* ==================== LEFT SIDEBAR ==================== */}
      <Grid item xs={12} md={3}>
        <Box className="view-release-sidebar">
          {/* Album Artwork */}
          <div className="sidebar-artwork">
            <div
              className={`image-div ${(recipeFilePreview || album_artwork) && !imageError ? 'image-preview-clickable' : ''}`}
              onClick={() => (recipeFilePreview || album_artwork) && !imageError && setOpenImagePreview(true)}
              title={(recipeFilePreview || album_artwork) && !imageError ? "Click to preview" : ""}
            >
              {(recipeFilePreview || album_artwork) && !imageError ? (
                <img
                  src={recipeFilePreview || `${API_URL}/${album_artwork}`}
                  alt="Album Artwork"
                  onError={() => setImageError(true)}
                />
              ) : null}
              <div className="sidebar-artwork__no-image" style={(recipeFilePreview || album_artwork) && !imageError ? { display: 'none' } : {}}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
                <span>No image available</span>
              </div>
            </div>

            {/* Artwork action buttons */}
            <Accordion className="sidebar-poster-actions" disableGutters>
              <AccordionSummary expandIcon={<ChevronDown size={16} />}>
                <Typography variant="subtitle2">Poster Actions</Typography>
              </AccordionSummary>
              <AccordionDetails className="sidebar-poster-actions__content">
                <a
                  href={recipeFilePreview || `${API_URL}/${album_artwork}`}
                  download="artwork"
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: 'none', display: 'block' }}
                >
                  <ActionButton variant="settle">Download</ActionButton>
                </a>
                {recipeFilePreview ? (
                  <ActionButton variant="success" onClick={onSaveUpdatedArtwork}>
                    Save
                  </ActionButton>
                ) : (
                  <ActionButton variant="success" component="label">
                    <input
                      type="file"
                      accept="image/x-png,image/gif,image/jpeg"
                      onChange={onFileHandler}
                      hidden
                    />
                    Update Poster
                  </ActionButton>
                )}
                <ActionButton variant="danger" onClick={() => onDelete(album_artwork)}>
                  Delete
                </ActionButton>
              </AccordionDetails>
            </Accordion>
          </div>

          {/* User Info */}
          <Box mt={2} className="sidebar-user-info">
            <CopyableField label="User" value={name} raw />
            <CopyableField label="Email" value={email} raw />
          </Box>

          {/* Resubmission Alert */}
          {status === "in_review" && reason && (
            <Box mt={2} sx={{
              background: 'rgba(239, 68, 68, 0.06)',
              border: '1px solid rgba(239, 68, 68, 0.2)',
              borderLeft: '3px solid #EF4444',
              borderRadius: '6px',
              overflow: 'hidden',
            }}>
              {/* Header */}
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 1.5,
                py: 1,
                borderBottom: '1px solid rgba(239, 68, 68, 0.12)',
                background: 'rgba(239, 68, 68, 0.06)',
              }}>
                <RotateCcw size={13} color="#EF4444" />
                <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#EF4444', letterSpacing: '0.03em', textTransform: 'uppercase' }}>
                  Resubmission
                </Typography>
              </Box>
              {/* Body */}
              <Box sx={{ px: 1.5, py: 1.25 }}>
                <Typography sx={{ fontSize: '0.7rem', fontWeight: 600, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.04em', mb: 0.5 }}>
                  Previous Rejection Reason
                </Typography>
                <Typography sx={{
                  fontSize: '0.8rem',
                  color: 'var(--text-primary)',
                  lineHeight: 1.6,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}>
                  {reason}
                </Typography>
              </Box>
            </Box>
          )}

          {/* Context-appropriate Actions */}
          {status === "in_review" && (
            <Box mt={2} className="sidebar-actions">
              <Typography variant="subtitle2" className="sidebar-actions__title">Actions</Typography>
              <div className="sidebar-actions__buttons">
                <ActionButton variant="success" onClick={() => onClickAccept(release_id)}>
                  Accept
                </ActionButton>
                <ActionButton variant="danger" onClick={() => onClickReject(release_id)}>
                  Reject
                </ActionButton>
              </div>
            </Box>
          )}

          {status === "approved" && (
            <Box mt={2} className="sidebar-actions">
              <Typography variant="subtitle2" className="sidebar-actions__title">Actions</Typography>
              <div className="sidebar-actions__buttons">
                <ActionButton variant="success" onClick={() => setEditModal(true)}>
                  Edit
                </ActionButton>
                <ActionButton variant="settle" onClick={() => setOpenPromotion(true)}>
                  Promote
                </ActionButton>
              </div>
              <div className="sidebar-actions__buttons" style={{ marginTop: 8 }}>
                <ActionButton variant="warning" onClick={() => onClickTakeDown(release_id)}>
                  Take Down
                </ActionButton>
                <ActionButton variant="danger" onClick={() => onClickReject(release_id)}>
                  Reject
                </ActionButton>
              </div>
            </Box>
          )}

          {status === "rejected" && (
            <Box mt={2} className="sidebar-actions">
              <Typography variant="subtitle2" className="sidebar-actions__title">Actions</Typography>
              <div className="sidebar-actions__buttons">
                <ActionButton variant="danger" onClick={() => onDeleteRejectedRelease(release_id)}>
                  Delete Release
                </ActionButton>
              </div>
            </Box>
          )}

          {/* Internal Notes (read-only) */}
          {internal_notes && (
            <Box mt={2} sx={{
              backgroundColor: 'var(--bg-elevated)',
              borderRadius: '8px',
              border: '1px solid var(--border)',
              p: 2,
            }}>
              <Box display="flex" alignItems="center" gap={0.75} mb={1}>
                <StickyNote size={15} color="#6C63FF" />
                <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'var(--text-primary)', fontSize: '0.85rem' }}>
                  Internal Notes
                </Typography>
              </Box>
              <Divider sx={{ mb: 1.5, borderColor: 'var(--border)' }} />
              <Box>
                {internal_notes.split("\n").reduce((acc, line, i, arr) => {
                  if (line.trim() === "") {
                    if (i > 0 && arr[i - 1].trim() !== "") {
                      acc.push(<Box key={`sp-${i}`} sx={{ height: 8 }} />);
                    }
                    return acc;
                  }
                  if (line.startsWith("\u2022 ")) {
                    acc.push(
                      <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, py: 0.3, pl: 1 }}>
                        <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#6C63FF', mt: '7px', flexShrink: 0 }} />
                        <Typography variant="body2" sx={{ color: 'var(--text-primary)', fontSize: '0.82rem', lineHeight: 1.6 }}>
                          {line.slice(2)}
                        </Typography>
                      </Box>
                    );
                  } else if (/^\d+\.\s/.test(line)) {
                    const match = line.match(/^(\d+)\.\s(.*)/);
                    acc.push(
                      <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, py: 0.3, pl: 1 }}>
                        <Typography variant="body2" sx={{ color: '#6C63FF', fontWeight: 600, fontSize: '0.82rem', lineHeight: 1.6, minWidth: 18 }}>
                          {match[1]}.
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'var(--text-primary)', fontSize: '0.82rem', lineHeight: 1.6 }}>
                          {match[2]}
                        </Typography>
                      </Box>
                    );
                  } else {
                    acc.push(
                      <Typography key={i} variant="body2" sx={{ color: 'var(--text-primary)', fontSize: '0.82rem', lineHeight: 1.6, py: 0.3, textAlign: 'left' }}>
                        {line}
                      </Typography>
                    );
                  }
                  return acc;
                }, [])}
              </Box>
            </Box>
          )}
        </Box>
      </Grid>

      {/* ==================== RIGHT CONTENT ==================== */}
      <Grid item xs={12} md={9}>
        <Box className="view-release-content">

          {/* Section 1: Release Information */}
          <Paper className="section-card">
            <Typography variant="h6" className="section-card__title">Release Information</Typography>
            <Divider sx={{ mb: 2, borderColor: 'var(--border)' }} />
            <CopyableField label="Release Title" value={release_title} />
            <CopyableField label="Release Type" value={release_type ? release_type.charAt(0).toUpperCase() + release_type.slice(1) : ''} />
            <CopyableField label="Label" value={lable_name} />
            <CopyableField label="Genre" value={genre} />
            <CopyableField label="Sub-genre" value={sub_genre} />
            <CopyableField label="Number of Tracks" value={number_of_tracks} />
            <CopyableField label="Release Date" value={moment(Number(release_date)).format("DD/MM/yyyy")} />
            <CopyableField label="Original Release Date" value={moment(Number(ogn_release_date)).format("DD/MM/yyyy")} />
            <CopyableField label="UPC/EAN" value={upc_ean} highlight="#EF4444" />
          </Paper>

          {/* Section 2: Copyright & Metadata */}
          <Paper className="section-card">
            <Typography variant="h6" className="section-card__title">Copyright & Metadata</Typography>
            <Divider sx={{ mb: 2, borderColor: 'var(--border)' }} />
            <CopyableField label="C Line" value={c_line} />
            <CopyableField label="P Line" value={p_line} />
            <CopyableField label="Courtesy Line" value={cour_line} />
            <CopyableField label="CRBT" value={crbt} />
            <CopyableField label="Video Platforms" value={video_platforms} />
            <CopyableField label="Price Tier" value={Array.isArray(audios) && audios.length ? audios[0].price_tier : '-'} />
            <CopyableField label="Explicit Version" value={Array.isArray(audios) && audios.length ? audios[0].explicit_version : '-'} />
            <Box display="flex" alignItems="flex-start" sx={{ padding: '6px 0', borderBottom: '1px solid rgba(255, 255, 255, 0.04)' }}>
              <Typography sx={{ minWidth: 160, fontSize: '0.82rem', fontWeight: 600, color: 'var(--text-secondary)', flexShrink: 0, pt: 0.25 }}>
                Additional Info
              </Typography>
              <Box sx={{
                flex: 1,
                minWidth: 0,
                maxHeight: 160,
                overflowY: 'auto',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontSize: '0.88rem',
                color: add_info ? '#F59E0B' : 'var(--text-primary)',
                fontWeight: add_info ? 600 : 400,
              }}>
                {add_info || '-'}
              </Box>
              {add_info && (
                <IconButton size="small" onClick={() => copyToClipboard(add_info)} sx={{ color: 'var(--text-secondary)', '&:hover': { color: 'var(--primary)' }, flexShrink: 0, ml: 0.5 }}>
                  <Copy size={14} />
                </IconButton>
              )}
            </Box>
          </Paper>

          {/* Section 3: Artists */}
          <Paper className="section-card">
            <Typography variant="h6" className="section-card__title">Artists</Typography>
            <Divider sx={{ mb: 2, borderColor: 'var(--border)' }} />

            {/* Primary Artists */}
            {primary_artist1 && (
              <Box className="artist-group">
                <Typography variant="subtitle2" className="artist-group__heading">Primary Artist 1</Typography>
                <CopyableField label="Name" value={primary_artist1} />
                <CopyableField label="Apple ID" value={apple_id1} />
                <CopyableField label="Spotify ID" value={spotify_id1} />
              </Box>
            )}
            {primary_artist2 && (
              <Box className="artist-group">
                <Divider sx={{ my: 1.5, borderColor: 'var(--border)', opacity: 0.4 }} />
                <Typography variant="subtitle2" className="artist-group__heading">Primary Artist 2</Typography>
                <CopyableField label="Name" value={primary_artist2} />
                <CopyableField label="Apple ID" value={apple_id2} />
                <CopyableField label="Spotify ID" value={spotify_id2} />
              </Box>
            )}
            {primary_artist3 && (
              <Box className="artist-group">
                <Divider sx={{ my: 1.5, borderColor: 'var(--border)', opacity: 0.4 }} />
                <Typography variant="subtitle2" className="artist-group__heading">Primary Artist 3</Typography>
                <CopyableField label="Name" value={primary_artist3} />
                <CopyableField label="Apple ID" value={apple_id3} />
                <CopyableField label="Spotify ID" value={spotify_id3} />
              </Box>
            )}

            {/* Featuring Artists */}
            {featuring1 && (
              <Box className="artist-group">
                <Divider sx={{ my: 1.5, borderColor: 'var(--border)', opacity: 0.4 }} />
                <Typography variant="subtitle2" className="artist-group__heading">Featuring Artist 1</Typography>
                <CopyableField label="Name" value={featuring1} />
                <CopyableField label="Apple ID" value={apple_id1f} />
                <CopyableField label="Spotify ID" value={spotify_id1f} />
              </Box>
            )}
            {featuring2 && (
              <Box className="artist-group">
                <Divider sx={{ my: 1.5, borderColor: 'var(--border)', opacity: 0.4 }} />
                <Typography variant="subtitle2" className="artist-group__heading">Featuring Artist 2</Typography>
                <CopyableField label="Name" value={featuring2} />
                <CopyableField label="Apple ID" value={apple_id2f} />
                <CopyableField label="Spotify ID" value={spotify_id2f} />
              </Box>
            )}
            {featuring3 && (
              <Box className="artist-group">
                <Divider sx={{ my: 1.5, borderColor: 'var(--border)', opacity: 0.4 }} />
                <Typography variant="subtitle2" className="artist-group__heading">Featuring Artist 3</Typography>
                <CopyableField label="Name" value={featuring3} />
                <CopyableField label="Apple ID" value={apple_id3f} />
                <CopyableField label="Spotify ID" value={spotify_id3f} />
              </Box>
            )}
          </Paper>

        </Box>
      </Grid>

      {/* ==================== TRACKS (full width) ==================== */}
      <Grid item xs={12} id="tracks-section">
        <Divider sx={{ mb: 3, borderColor: 'var(--border)' }} />
        <Paper className="section-card">
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Typography variant="h6" className="section-card__title" style={{ marginBottom: 0 }}>Tracks</Typography>
            <ActionButton variant="settle" onClick={() => setEditAudioModal(true)}>
              Edit Tracks
            </ActionButton>
          </Box>
          <Divider sx={{ mb: 2, borderColor: 'var(--border)' }} />
          <TableContainer>
            <Table className="universal-table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell>No.</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Artist</TableCell>
                  <TableCell>Genre</TableCell>
                  <TableCell>Product Number</TableCell>
                  <TableCell>ISRC</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {audios && audios.length
                  ? audios.map((item, key) => (
                      <TableRow
                        key={key}
                        onClick={() => onOpenModal(item)}
                        hover
                        style={{ cursor: 'pointer' }}
                      >
                        <TableCell>{key + 1}</TableCell>
                        <TableCell>{item.title}</TableCell>
                        <TableCell>{item.primary_artist1}</TableCell>
                        <TableCell>{item.genre}</TableCell>
                        <TableCell>{`FM-AU-${item.audio_id}`}</TableCell>
                        <TableCell>{item.isrc || '-'}</TableCell>
                        <TableCell>
                          <StatusBadge status={trackStatusMap[item.status] || 'pending'} />
                        </TableCell>
                      </TableRow>
                    ))
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>

      {/* ==================== MODALS (unchanged) ==================== */}
      <CustomShowModal
        open={openSong}
        handleClose={() => setOpenSong(false)}
        maxWidth="md"
        title="Song Details"
      >
        <ViewSong selectedSong={selectedSong} />
      </CustomShowModal>

      <ConfirmModal
        open={openConfirm}
        message={`Are you sure you want to accept this release?`}
        title={`Confirmation`}
        onSubmitConfirm={onConfirmAcceptModal}
        handleClose={() => setOpenConfirm(false)}
      />

      <ConfirmModal
        open={openTakedownConfirm}
        message={`Are you sure you want to take down this release?`}
        title={`Confirmation`}
        onSubmitConfirm={onConfirmTakeDown}
        handleClose={() => setOpenTakedownConfirm(false)}
      />

      <CustomAddModal
        open={openReject}
        saveLabel="Send"
        title="Add Reason"
        handleClose={() => setOpenReject(false)}
        onSubmitConfirm={onSubmitReject}
      >
        <Grid container style={{ height: "330px", display: "block" }}>
          <Grid item xs={12} style={{ marginBottom: "20px", height: "40px" }}>
            <SelectCMP
              options={rejectOptions}
              // value={selectedTicketType}
              placeholder="Select Reason"
              onChange={(e) => setReasonText(e.value)}
              styles={darkSelectStyles}
            />
          </Grid>

          <Grid item xs={12} style={{ height: "calc(100% - 60px)" }}>
            <textarea
              className="text-area-input"
              placeholder="Please add a reason"
              value={reasonText}
              onKeyPress={keyPressedReason}
              onChange={(e) => setReasonText(e.target.value)}
            />
          </Grid>
        </Grid>
      </CustomAddModal>

      <CustomAddModal
        open={showSongModal}
        disableOutClick
        disableSave
        saveLabel="Skip"
        title="Reject a song?"
        handleClose={() => setShowSongModal(false)}
        onSubmitConfirm={() => setShowSongModal(false)}
      >
        <Grid container>
          <Grid item xs={12}>
            <h5>Note: Please skip if you don't want to reject a song.</h5>
            <Box mt={2}>
              <Table className="universal-table">
                <TableHead>
                  <TableRow>
                    <TableCell>No.</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {audios && audios.length
                    ? audios.map((item, key) => {
                        return (
                          <TableRow key={key} hover>
                            <TableCell>{key + 1}</TableCell>
                            <TableCell>{item.title}</TableCell>
                            <TableCell>
                              {item.status === 0 ? (
                                <ActionButton
                                  variant="danger"
                                  onClick={() => onRejectASong(item.audio_id)}
                                >
                                  Reject
                                </ActionButton>
                              ) : (
                                "Rejected"
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    : null}
                </TableBody>
              </Table>
            </Box>
          </Grid>
        </Grid>
      </CustomAddModal>

      <CustomAddModal
        open={openPromotion}
        saveLabel="Create"
        title="Create Promotion"
        handleClose={() => setOpenPromotion(false)}
        onSubmitConfirm={() => onCreatePromotion(false)}
      >
        <Grid container style={{ height: "350px", display: "block" }}>
          <TextField
            label="Song Name"
            variant="outlined"
            size="small"
            value={promotionData.song}
            onChange={(e) =>
              setPromotionData((prev) => ({
                ...prev,
                song: e.target.value,
              }))
            }
            fullWidth
          />
          <Grid
            item
            xs={12}
            style={{ marginBottom: "10px", marginTop: "10px", height: "40px" }}
          >
            <SelectCMP
              options={platformOptions}
              value={promotionData.platform}
              placeholder="Select Platform"
              styles={darkSelectStyles}
              onChange={(selectedOption) =>
                setPromotionData((prev) => ({
                  ...prev,
                  platform: selectedOption,
                }))
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{ marginBottom: "10px", marginTop: "10px", height: "40px" }}
          >
            <SelectCMP
              options={promoOptions}
              value={promotionData.promotion}
              placeholder="Select Promotion Type"
              styles={darkSelectStyles}
              onChange={(selectedOption) =>
                setPromotionData((prev) => ({
                  ...prev,
                  promotion: selectedOption,
                }))
              }
            />
          </Grid>

          <Grid
            item
            xs={12}
            style={{ marginBottom: "10px", marginTop: "10px" }}
          >
            <TextField
              label="Promotion / Playlist Name"
              variant="outlined"
              size="small"
              value={promotionData.playlist_name}
              onChange={(e) =>
                setPromotionData((prev) => ({
                  ...prev,
                  playlist_name: e.target.value,
                }))
              }
              fullWidth
            />
          </Grid>

          <Grid
            item
            xs={12}
            style={{ marginBottom: "10px", marginTop: "10px" }}
          >
            <TextField
              label="Promotion / Playlist Link"
              variant="outlined"
              size="small"
              value={promotionData.playlist_link}
              onChange={(e) =>
                setPromotionData((prev) => ({
                  ...prev,
                  playlist_link: e.target.value,
                }))
              }
              fullWidth
            />
          </Grid>

          <Grid item xs={12} style={{ margin: "10px 0" }}>
            <input
              accept="image/*"
              style={{ display: "none" }}
              id="upload-image"
              type="file"
              onChange={onPromotionFileHandler}
            />
            <label htmlFor="upload-image">
              <Button variant="contained" color="primary" component="span">
                Upload Image
              </Button>
            </label>

            {imagePreview && (
              <Grid item xs={12} style={{ marginTop: "10px" }}>
                <Box
                  component="div"
                  style={{
                    width: "100%",
                    maxHeight: 200,
                    overflow: "hidden",
                    borderRadius: 8,
                  }}
                >
                  <p style={{ fontSize: "20px", fontWeight: 400 }}>Preview:</p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={`${API_URL}/${imagePreview}`}
                      alt="Preview"
                      style={{ width: "60%", objectFit: "cover", height: "50%" }}
                    />
                  </div>
                </Box>
              </Grid>
            )}
          </Grid>
                  <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginRight: "-17px",
          }}
        >
          <Button
            onClick={() => onCreatePromotion(true)}
            color="secondary"
            variant="contained"
            className="font-family"
            autoFocus
          >
            Create & Email
          </Button>
        </div>
        </Grid>

      </CustomAddModal>

      <CustomAddModal
        open={editModal}
        saveLabel="Save"
        title="Edit Release Details"
        handleClose={() => setEditModal(false)}
        onSubmitConfirm={() => onEditRelease()}
      >
        <Grid container style={{ height: "350px", display: "block" }}>
          <Grid
            item
            xs={12}
            style={{ marginBottom: "10px", marginTop: "10px" }}
          >
            <TextField
              label="Label Name"
              variant="outlined"
              size="small"
              value={editRelease.lable_name}
              onChange={(e) =>
                setEditRelease((prev) => ({
                  ...prev,
                  lable_name: e.target.value,
                }))
              }
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{ marginBottom: "10px", marginTop: "10px" }}
          >
            <TextField
              label="Release Title"
              variant="outlined"
              size="small"
              value={editRelease.release_title}
              onChange={(e) =>
                setEditRelease((prev) => ({
                  ...prev,
                  release_title: e.target.value,
                }))
              }
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{ marginBottom: "10px", marginTop: "10px" }}
          >
            <Box
              p={1}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <InputLabel htmlFor="Releasedate">Release Date:</InputLabel>

              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  format="dd/MM/yyyy"
                  value={
                    editRelease.release_date && !isNaN(editRelease.release_date)
                      ? new Date(Number(editRelease.release_date))
                      : null
                  }
                  onChange={(date) =>
                    setEditRelease({
                      ...editRelease,
                      release_date: date ? date.getTime() : null,
                    })
                  }
                  slotProps={{
                    textField: {
                      margin: "normal",
                      size: "medium",
                    }
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ marginBottom: "10px", marginTop: "10px" }}
          >
            <TextField
              label="UPC/EAN"
              variant="outlined"
              size="small"
              value={editRelease.upc_ean}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                setEditRelease((prev) => ({
                  ...prev,
                  upc_ean: value,
                }));
              }}
              inputProps={{ maxLength: 13 }}
              helperText="Must be 12 or 13 digits"
              fullWidth
            />
          </Grid>
        </Grid>
      </CustomAddModal>

      <CustomAddModal
        open={editAudioModal}
        saveLabel="Save"
        title="Edit Track Names"
        handleClose={() => setEditAudioModal(false)}
        onSubmitConfirm={() => onEditTracks()}
      >
        <Grid container style={{ height: "auto", display: "block" }}>
          {editAudio?.map((value, index) => {
            return (
              <Grid
                item
                key={index}
                xs={12}
                style={{ marginTop: "10px" }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p
                    style={{
                      marginRight: "10px",
                      fontSize: "15px",
                      fontWeight: 500,
                      minWidth: "24px",
                    }}
                  >
                    {index + 1}:{" "}
                  </p>
                  <TextField
                    label="Title"
                    variant="outlined"
                    size="small"
                    value={value.title}
                    onChange={(e) => handleAudioChange(index, "title", e.target.value)}
                    fullWidth
                  />
                </div>
                <TextField
                  placeholder="ISRC"
                  variant="outlined"
                  size="small"
                  value={value.isrc}
                  onChange={(e) => {
                    const filtered = e.target.value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
                    handleAudioChange(index, "isrc", filtered);
                  }}
                  inputProps={{ maxLength: 12, style: { fontSize: "0.85rem" } }}
                  helperText="12 alphanumeric chars"
                  FormHelperTextProps={{ style: { fontSize: "0.65rem", whiteSpace: "nowrap", margin: "2px 0 0" } }}
                  style={{ marginLeft: "34px", marginTop: "6px", width: "160px" }}
                />
              </Grid>
            );
          })}
        </Grid>
      </CustomAddModal>

      <ImagePreviewModal
        open={openImagePreview}
        handleClose={() => setOpenImagePreview(false)}
        imageSrc={recipeFilePreview || `${API_URL}/${album_artwork}`}
        title="Album Artwork"
      />
    </Grid>
  );
}

export default ViewReleases;
